<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('/searchkeys')">
            <i class="ksi ksi-searchkeys"></i>
            <span>{{ $t('lang.menu.search_keys') }}</span>
        </a>
        <a :href="getLink('/similarkeys')">
            <i class="ksi ksi-similarkeys"></i>
            <span>{{ $t('lang.menu.similar_keys') }}</span>
        </a>
        <a :href="getLink('/tools/extended-keywords')">
            <i class="ksi ksi-tools-extended-keywords"></i>
            <span>{{ $t('lang.menu.tools_extended_keywords') }}</span>
        </a>
        <a :href="getLink('/tools/check-top')">
            <i class="ksi ksi-tools-check-top"></i>
            <span>{{ $t('lang.menu.tools_check_top') }}</span>
        </a>
        <a :href="getLink('/tools/history-serp')">
            <i class="ksi ksi-tools-history-serp"></i>
            <span>{{ $t('lang.menu.tools_history_serp') }}</span>
        </a>
        <a :href="getLink('/tools/keywords-by-list')">
            <i class="ksi ksi-tools-keywords-by-list"></i>
            <span>{{ $t('lang.menu.tools_keywords_by_list') }}</span>
        </a>
        <a :href="getLink('/tools/compare')">
            <i class="ksi ksi-tools-compare"></i>
            <span>{{ $t('lang.menu.tools_compare') }}</span>
        </a>
        <a :href="getLink('/tools/combine')">
            <i class="ksi ksi-tools-combine"></i>
            <span>{{ $t('lang.menu.tools_combine') }}</span>
        </a>
        <a :href="getLink('/tools/delete-double')">
            <i class="ksi ksi-tools-delete-double"></i>
            <span>{{ $t('lang.menu.tools_delete_double') }}</span>
        </a>
        <a :href="getLink('/tools/unique')">
            <i class="ksi ksi-tools-unique"></i>
            <span>{{ $t('lang.menu.tools_unique') }}</span>
        </a>
        <a :href="getLink('/tools/suggest')">
            <i class="ksi ksi-tools-suggest"></i>
            <span>{{ $t('lang.menu.tools_suggest') }}</span>
        </a>
        <a :href="getLink('/wordstat-list')">
            <i class="ksi ksi-wordstat-list"></i>
            <span>{{ $t('lang.menu.wordstat_list') }}</span>
        </a>
        <a :href="getLink('/serp-list')">
            <i class="ksi ksi-serp-list"></i>
            <span>{{ $t('lang.menu.serp_list') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";

export default {
    name: "MenuSubmenuTopKeywords",
    data() {
        return {
            listenerId: Listeners.TOP_MENU_TOP_KEYWORDS_HOVER,
        };
    },
    methods: {
        getLink(url) {
            return sprintf('/%s%s', window.locale, url);
        },
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
